export let OAuthScope;

(function (OAuthScope) {
  OAuthScope["PROFILE_READ"] = "PROFILE:READ";
  OAuthScope["PHONE_READ"] = "PHONE:READ";
  OAuthScope["ASSETS_READ"] = "ASSETS:READ";
  OAuthScope["COLLECTIBLES_READ"] = "COLLECTIBLES:READ";
  OAuthScope["CONTACTS_READ"] = "CONTACTS:READ";
  OAuthScope["MESSAGES_REPRESENT"] = "MESSAGES:REPRESENT";
  OAuthScope["SNAPSHOTS_READ"] = "SNAPSHOTS:READ";
  OAuthScope["CIRCLES_READ"] = "CIRCLES:READ";
  OAuthScope["CIRCLES_WRITE"] = "CIRCLES:WRITE";
})(OAuthScope || (OAuthScope = {}));